import { Radio, Tabs } from 'antd';
import DailyReportStatement from './DailyReportStatement';
import CashSettlement from 'pages/fms/cash-settlement';
import CashSettlementHistory from 'pages/fms/cash-settlement/cash-settlement-history';
// import ShopCash from 'pages/fms/shop-cash';
import { Trans } from 'react-i18next';
import LOCALS from 'commons/locals';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectUserInfo } from 'store/slices/userInfoSlice';
import { SHOP_MAP } from 'constant/shop';

const DailyReportPage = () => {
  const { shop: userShop } = useAppSelector(selectUserInfo);
  const shopOptionList = useMemo(
    () => [
      { value: SHOP_MAP.GINZA, label: <Trans i18nKey={LOCALS.ginza_shop} /> },
      {
        value: SHOP_MAP.HONGKONG,
        label: <Trans i18nKey={LOCALS.hongkong_shop} />,
      },
      {
        value: SHOP_MAP.SINGAPORE,
        label: <Trans i18nKey={LOCALS.singapore_shop} />,
      },
      {
        value: SHOP_MAP.SINGAPORE_ASU_GST,
        label: <Trans i18nKey={LOCALS.singapore_shop_asu_gst} />,
      },
      {
        value: SHOP_MAP.SINGAPORE_GX,
        label: <Trans i18nKey={LOCALS.kkIwEnEVml} />,
      },
      { value: SHOP_MAP.UMEDA, label: <Trans i18nKey={LOCALS.umeda_store} /> },
      { value: SHOP_MAP.DUBAI, label: <Trans i18nKey={LOCALS.dubai_store} /> },
      {
        value: SHOP_MAP.FRANCE,
        label: <Trans i18nKey={LOCALS.france_store} />,
      },
      {
        value: SHOP_MAP.NEW_YORK,
        label: <Trans i18nKey={LOCALS.new_york_store} />,
      },
    ],
    [],
  );

  const allowedShopIds = useMemo(
    () => shopOptionList.map((opt) => opt.value as number),
    [shopOptionList],
  );

  const getInitialShop = () =>
    userShop && allowedShopIds.includes(userShop) ? userShop : SHOP_MAP.GINZA;

  const [selectedShopId, setSelectedShopId] = useState<number>(getInitialShop);
  const [hasUserChangedShop, setHasUserChangedShop] = useState(false);

  useEffect(() => {
    if (userShop && allowedShopIds.includes(userShop) && !hasUserChangedShop)
      setSelectedShopId(userShop);
  }, [userShop, allowedShopIds, hasUserChangedShop]);

  return (
    <div className="w-full">
      <div className="flex justify-center mb-4">
        <Radio.Group
          optionType="button"
          buttonStyle="solid"
          options={shopOptionList}
          value={selectedShopId}
          onChange={(e) => {
            setSelectedShopId(e.target.value);
            setHasUserChangedShop(true);
          }}
        />
      </div>

      <Tabs
        defaultActiveKey="statement"
        destroyInactiveTabPane
        items={[
          // {
          //   key: 'shop_cash',
          //   label: <Trans i18nKey={LOCALS.shop_cash} />,
          //   children: <ShopCash selectedShopId={selectedShopId} />,
          // },
          {
            key: 'statement',
            label: <Trans i18nKey={LOCALS.nikkei_table} />,
            children: <DailyReportStatement selectedShopId={selectedShopId} />,
          },
          {
            key: 'cash_settlement',
            label: <Trans i18nKey={LOCALS.rmRaikouFN} />,
            children: (
              <CashSettlement
                selectedShopId={selectedShopId}
                showShopSelector={false}
                showHistoryButton={false}
              />
            ),
          },
          {
            key: 'cash_settlement_history',
            label: <Trans i18nKey={LOCALS.YrUIIgiGqm} />,
            children: <CashSettlementHistory shopId={selectedShopId} />,
          },
        ]}
      />
    </div>
  );
};

export default DailyReportPage;
